import { Doughnut } from "react-chartjs-2"
import { ArcElement, Chart } from "chart.js"
import classNames from "classnames"

import styles from "./index.module.scss"

Chart.register(ArcElement)

export type ChartOptions = {
  cutout?: string
  rotation?: number
  circumference?: number
}

interface Props {
  values: number[]
  className?: string
  colors: string[]
  options?: ChartOptions
}

const DEFAULT_OPTIONS = {
  cutout: "60%",
  rotation: -90,
  circumference: 180,
} as const

export const RainbowChart = ({ className, values, colors, options = {} }: Props) => {
  const {
    cutout = DEFAULT_OPTIONS.cutout,
    rotation = DEFAULT_OPTIONS.rotation,
    circumference = DEFAULT_OPTIONS.circumference,
  } = options
  const data = {
    datasets: [
      {
        data: values,
        backgroundColor: colors,
        hoverBackgroundColor: colors,
        borderWidth: 4,
        display: true,
        borderColor: "#fff",
        hoverBorderColor: "#fff",
      },
    ],
  }

  return (
    <div className={classNames(styles.rainbowWrapper, className)}>
      <Doughnut
        data={data}
        options={{
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              enabled: false,
            },
          },
          elements: {
            arc: {
              borderRadius: 10,
            },
          },
          rotation,
          circumference,
          cutout,
          maintainAspectRatio: true,
          responsive: true,
        }}
      />
    </div>
  )
}
